import { companySales, pct, rate } from "@/lib/selectors";
import { maintRate } from "@/lib/maintenance";

export const SEALS = {
  ouro: { label: "Selo Ouro", min: 80 },
  prata: { label: "Selo Prata", min: 65 },
  bronze: { label: "Selo Bronze", min: 50 },
};

export const suggestSeal = (score) => Object.keys(SEALS).find((k) => score >= SEALS[k].min) || null;

export const companyScore = (s, c) => {
  const sales = Math.min(100, pct(companySales(s, c.id), c.salesGoal));
  const tasks = rate(s.tasks.filter((t) => t.companyId === c.id));
  const checklists = rate(s.checklists.filter((cl) => cl.companyId === c.id).flatMap((cl) => cl.items));
  const maintenance = maintRate(s, c.id);
  const score = Math.round(sales * 0.35 + tasks * 0.25 + checklists * 0.2 + maintenance * 0.2);
  return { ...c, parts: { sales, tasks, checklists, maintenance }, score, suggested: suggestSeal(score), seal: s.seals[c.id] || null };
};

export const companyRanking = (s) =>
  s.companies
    .map((c) => companyScore(s, c))
    .sort((a, b) => b.score - a.score)
    .map((r, i) => ({ ...r, position: i + 1 }));
